import React, { useState } from "react";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, geoMarkIcon, checkCircleIcon, awardIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";

function CourseEventsHeader({className}) {
  return (
    <div className={`${className || ""} course-inner-header course-event-inner-header`} >
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>The Complete Python Masterclass : Become a Python Engineer</h1>
              <p className="mb-1">Learn A-Z everything about Python, from the basics, to advanced topics like Python GUI, Python Data Analysis, and more!</p>
              <div className="d-flex align-items-center gap-1 my-3">
                <IconDesc
                  icon={awardIcon}
                  paraDesc="Certified"
                />
              </div>
              <div className="rating-wrapper d-block d-md-flex align-items-center gap-3 mb-3 mt-1">
                <IconDesc
                  icon={bookIcon}
                  paraDesc="Instructed by"
                  linkDesc="Gokul"
                  link="#"
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={checkCircleIcon}
                  paraDesc="Expiring on 29/07/2023"
                  className="mb-1 mb-md-0"
                />
                <IconDesc
                  icon={geoMarkIcon}
                  paraDesc="Informatica Netherland B. V. Edisonbaan 14a 3439 MN Nieuwegein, Netherlands"
                  className="mb-1 mb-md-0"
                />
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className="course-image-wrapper">
              <img src={SampleImage2} className="img-fluid" alt="Course Image" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseEventsHeader;
